import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose } from 'recompose';

import { querySelector } from '../../../utils';
import queryMetaHandler from '../../../utils/queryMetaHandler';
import omitProps from '../../../utils/omitProps';


const GetAllUserTimeEntryGroups = gql`
  query GetAllUserTimeEntryGroupsQuery($startDate: String!, $endDate: String!) {
    all_user_time_entry_groups(start_date: $startDate, end_date: $endDate) {
      summary {
        pto {
          toString: to_string
        }
        workedHours: worked_hours {
          toString: to_string
        }
        guaranteed {
          toString: to_string
        }
        totalHours: total_hours {
          toString: to_string
        }
        paidNonLaborDuration: paid_non_labor_duration {
          toString: to_string
        }
        paidTotalDuration: paid_total_duration {
          toString: to_string
        }
        paidLaborDuration: paid_labor_duration {
          toString: to_string
        }
      }
      edges {
        node {
          user {
            payrollType: payroll_type
            firstname
            lastname
            defaultDistrict: default_district {
              id
              name
            }
            defaultDepartment: default_department {
              id
              name
            }
          }
          pto {
            toString: to_string
            totalSeconds: total_seconds
          }
          workedHours: worked_hours {
            toString: to_string
            totalSeconds: total_seconds
          }
          guaranteed {
            toString: to_string
            totalSeconds: total_seconds
          }
          totalHours: total_hours {
            toString: to_string
            totalSeconds: total_seconds
          }
          paidNonLaborDuration: paid_non_labor_duration {
            toString: to_string
            totalSeconds: total_seconds
          }
          paidTotalDuration: paid_total_duration {
            toString: to_string
            totalSeconds: total_seconds
          }
          paidLaborDuration: paid_labor_duration {
            toString: to_string
            totalSeconds: total_seconds
          }
        }
      } 
    }
  }
`;

const marshallData = ({ data, ownProps }) => {
  const allUserTimeEntryGroups = querySelector(data, '$.all_user_time_entry_groups.edges[*].node', []);
  const [summary] = querySelector(data, '$.all_user_time_entry_groups.summary', []);

  return {
    ...ownProps,
    data,
    allUserTimeEntryGroups,
    summary,
  };
};

const queryGetAllUserTimeEntryGroupsData = graphql(GetAllUserTimeEntryGroups, {
  props: marshallData,
});

export const queryGetAllUserTimeEntryGroupsDataGQL = compose(
  queryGetAllUserTimeEntryGroupsData,
  queryMetaHandler,
  omitProps(['data']),
);
